// @ts-nocheck
import gaConfig from '@framework/config/ga';
import isDefined from '@framework/data-helpers/isDefined';
import isServer from '@framework/router/Next/isServer';
import { getTrackingIdGoogleAnalytics } from './helpers';
import { IUser } from '@users/user/vo/User';
import type { TNonce } from '@framework/router/Next/headers/ContentSecurityPolicyHeader/TNonce';

class GoogleAnalytics {
  static gtag(): void {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }

  static track(
    eventName: string,
    payload: Record<string, string | number>,
  ): void {
    GoogleAnalytics.gtag('event', eventName, payload);
  }

  static init(currentUser?: IUser, nonce: TNonce = ''): boolean {
    const trackingId = getTrackingIdGoogleAnalytics();

    if (isDefined(trackingId) && !isServer()) {
      navigator.sendBeacon = navigator.sendBeacon.bind(navigator);

      const s = document.createElement('script');
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ trackingId }`;
      s.async = true;
      if (nonce) {
        s.setAttribute('nonce', nonce);
      }

      document.head.insertBefore(s, document.head.firstChild);

      window.dataLayer = window.dataLayer || [];

      GoogleAnalytics.gtag('js', new Date());
      GoogleAnalytics.gtag('config', trackingId, {
        ...(currentUser?.id && {
          user_id: currentUser.id,
        }),
        send_page_view: false,
        linker: {
          domains: gaConfig.linkerDomains,
        },
      });

      if (currentUser?.companyId) {
        GoogleAnalytics.gtag('set', 'user_properties', {
          account_id: currentUser.companyId,
        });
      }

      return true;
    }

    return false;
  }
}

export default GoogleAnalytics;
